export const itemsAddedEventType = 'ok_autoLoadItemsAddedEvent';

export interface IItemsAddedEventData {
    container: HTMLElement;
    elements: HTMLElement[];
    operation: string;
}

export function dispatchItemsAddedEvent(data?: IItemsAddedEventData) {
    if (typeof window.CustomEvent === 'function') {
        window.document.dispatchEvent(new CustomEvent(itemsAddedEventType, {bubbles: true, detail: data}));
    }
}
